import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import path from 'path';

import { FilePreviewer } from 'libs/rendering/preview';
import { Checkbox } from 'libs/forms/styles';

import { Divider, Center } from 'legacyComponents/styled/lib';
import Button from 'components/Button';
import Spinner from 'components/Spinner';

import {
  FinderColumn,
  FileName,
  FileDetails,
  EmbedSettingsRow,
  EmbedOptionWrapper,
  EmbedOption,
} from 'apps/finder/styles';

class EmbedSettingsStore {
  @observable useCurrentVersion = false;

  @action
  SetUseCurrentVersion = bool => {
    this.useCurrentVersion = bool;
  };
}

@observer
export class FileColumn extends React.Component {
  constructor() {
    super();
    this.store = new EmbedSettingsStore();
  }

  render() {
    const { manager, selectFileAction } = this.props;
    const { file, fileQueryLoading } = manager;

    if (fileQueryLoading) {
      return (
        <FinderColumn>
          <Spinner margin='30px auto' />
        </FinderColumn>
      );
    }
    if ((file && file.isFolder) || !file) return null;
    const fileApp = file.file;
    const version = file.origin.version.substring(0, 7);
    const extension = path
      .extname(file.filename)
      .replace('.', '')
      .toUpperCase();

    const selectFileUrl = this.store.useCurrentVersion
      ? `${MAIN_URL}/${file.versionPath}`
      : `${MAIN_URL}/${file.headPath}`;

    return (
      <FinderColumn>
        <FilePreviewer
          viewerURL={`${MAIN_URL}/${file.headPath}`}
          isFinderPreview
        />
        <FileName>{file.filename}</FileName>
        <FileDetails>
          {extension}
          {fileApp?.sizeStr ? ` - ${fileApp.sizeStr}` : ''}
        </FileDetails>
        <Divider width='100%' margin='0 0 20px 0' />
        <Center>
          <Button
            size='small'
            text='Embed File'
            outline
            onClick={() => {
              selectFileAction(selectFileUrl, file.filename);
            }}
          />
        </Center>
        <EmbedSettingsRow>
          <EmbedOptionWrapper first>
            <EmbedOption>Latest</EmbedOption>
            <Checkbox
              id={this.inputId}
              type='checkbox'
              checked={!this.store.useCurrentVersion}
              onChange={() =>
                this.store.SetUseCurrentVersion(!this.store.useCurrentVersion)
              }
            />
          </EmbedOptionWrapper>
          <EmbedOptionWrapper>
            <EmbedOption>Current version (#{version})</EmbedOption>
            <Checkbox
              id={this.inputId}
              type='checkbox'
              checked={this.store.useCurrentVersion}
              onChange={() =>
                this.store.SetUseCurrentVersion(!this.store.useCurrentVersion)
              }
            />
          </EmbedOptionWrapper>
        </EmbedSettingsRow>
      </FinderColumn>
    );
  }
}

FileColumn.propTypes = {
  manager: PropTypes.object,
  selectFileAction: PropTypes.func,
};
